import * as React from "react";
type Props = {
  className?: string,
};
function SvgPerson({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-person"
      className={className}
    >
      <g clipPath="url(#clip0_1646_14538)">
        <path
          d="M10.33 9.06C10.4307 9.50187 10.6785 9.89643 11.0328 10.1791C11.387 10.4617 11.8268 10.6156 12.28 10.6156C12.7332 10.6156 13.173 10.4617 13.5272 10.1791C13.8815 9.89643 14.1293 9.50187 14.23 9.06M12.17 4C13.1829 4.0079 14.1707 4.31547 15.0091 4.88394C15.8474 5.45241 16.4987 6.25634 16.8809 7.1944C17.263 8.13245 17.3589 9.16264 17.1565 10.1551C16.9541 11.1476 16.4624 12.0579 15.7433 12.7714C15.0243 13.4848 14.1102 13.9694 13.1162 14.1642C12.1222 14.3589 11.0928 14.255 10.1577 13.8656C9.22265 13.4761 8.4238 12.8186 7.86186 11.9759C7.29992 11.1331 7.00003 10.1429 7 9.13C6.99998 8.45294 7.13398 7.78258 7.39429 7.15755C7.65459 6.53253 8.03605 5.96522 8.51666 5.48833C8.99727 5.01144 9.56752 4.6344 10.1945 4.37896C10.8216 4.12352 11.493 3.99472 12.17 4V4ZM20 20.86C20 17.22 16.42 14.26 12 14.26C7.58 14.26 4 17.26 4 20.86H20Z"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1646_14538">
          <rect
            width={18}
            height={18.86}
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgPerson;
